"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bag = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-bag` : '') + (description ? ` desc-bag` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bag"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bag"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.469,5.395 L14.531,5.395 C14.608,5.146 14.647,4.885 14.647,4.618 C14.647,3.154 13.462,1.969 12,1.969 C10.538,1.969 9.353,3.154 9.353,4.618 C9.353,4.885 9.392,5.145 9.469,5.395 L9.469,5.395 Z M1,6.063 C1.031,5.719 1.295,5.448 1.629,5.401 L1.731,5.394 L7.959,5.395 C7.91,5.141 7.886,4.88 7.886,4.618 C7.886,2.344 9.728,0.5 12,0.5 C14.272,0.5 16.115,2.344 16.115,4.618 C16.115,4.881 16.089,5.141 16.04,5.395 L22.27,5.394 L22.371,5.401 C22.704,5.448 22.97,5.719 23,6.063 L21.535,22.8 C21.518,23.186 21.199,23.5 20.802,23.5 L3.198,23.5 C2.8,23.5 2.482,23.186 2.465,22.8 L1,6.063 Z M20.001,22.032 L21.475,6.862 L2.525,6.862 L3.998,22.032 L20.001,22.032 Z",
    fill: "inherit"
  }));
};
var _default = exports.default = bag;